import { render } from "./PremiumPaywall.vue?vue&type=template&id=2c07f100&scoped=true"
import script from "./PremiumPaywall.vue?vue&type=script&lang=js"
export * from "./PremiumPaywall.vue?vue&type=script&lang=js"

import "./PremiumPaywall.vue?vue&type=style&index=0&id=2c07f100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c07f100"]])

export default __exports__